import { createAsyncAction } from 'typesafe-actions';
import { GetProjectsResponse, GetProjectsError, GetProjectsRequest } from './types';

export const projects = createAsyncAction(
  'GET_PROJECTS_REQUEST',
  'GET_PROJECTS_SUCCESS',
  'GET_PROJECTS_ERROR',
)<GetProjectsRequest, GetProjectsResponse[], GetProjectsError>();
